<mat-card appearance="outlined" class="mt-4" (mouseenter)='onMouseEnter()' (mouseleave)='onMouseLeave()'>
    <mat-card-content>
        <div class="transition-item-row">
            <mat-card-subtitle class="transition-roles text-muted">{{ roles() }}</mat-card-subtitle>
            <button mat-icon-button
                    [matMenuTriggerFor]="editMenu">
                <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #editMenu="matMenu">
                <button mat-menu-item
                        *ngIf="canEdit"
                        (click)="onEdit()">
                        <mat-icon>settings</mat-icon>
                        <span i18n>Edit transition</span>
                </button>
                <button mat-menu-item
                        *ngIf="canDelete"
                        (click)="onDelete()">
                        <mat-icon>delete</mat-icon>
                        <span i18n>Delete transition</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item
                        (click)="onAddAction()">
                        <mat-icon>add</mat-icon>
                        <span i18n>Add action</span>
                </button>
                <button mat-menu-item
                        *ngIf="canAddGuards"
                        (click)="onAddGuard()">
                        <mat-icon>add</mat-icon>
                        <span i18n>Add guard</span>
                </button>
            </mat-menu>
        </div>

        <div class="transition-item-row">
            <mat-card-title class="transition-name">{{ item.name }}</mat-card-title>
            <div class="transition-states">
                <app-badge *ngIf="!item.isInitialTransition" [title]="item.source.name"></app-badge>&nbsp;&#8594;&nbsp;<app-badge [title]="item.target.name"></app-badge>
            </div>
        </div>
        
        <hr *ngIf="shouldShowActions || shouldShowGuards" />

        <ng-container *ngIf="shouldShowActions">
            <eas-workflow-transition-action-list [actions]="item.actions"
                                                 [availableActions]="availableActions"
                                                 (editAction)="onEditAction($event)"
                                                 (didEditActions)="onDidEditActions($event)">
            </eas-workflow-transition-action-list>
        </ng-container>

        <ng-container *ngIf="shouldShowGuards">
            <eas-workflow-transition-guard-list [guards]="item.guards"
                                                [availableGuards]="availableGuards"
                                                (editGuard)="onEditGuard($event)"
                                                (didEditGuard)="onDidEditGuards($event)">
            </eas-workflow-transition-guard-list>
        </ng-container>
    </mat-card-content>
</mat-card>
